<template>
  <div class="main">
    <div>In order for us to integrate with your MobilePay account, please grant access</div>
    <div>by clicking on the button below.</div>
    <div style="margin-top:50px">
      <a :href=link>
        <img src="../../../assets/button.png" title="MobilePay" alt="MobilePay">
      </a>
    </div>
  </div>
</template>

<script>
import store from "../../../store";

export default {
  name: "AuthorizeMobilePay",
  created () {
    this.link = store.getters.getLink
  },
  data() {
    return {
      link: '#',
    };
  }
};
</script>

<style scoped>
.main {
  width: 100%;
  height: 100vh;
  font-size: 26px;
  display: flex;
  align-items: center;
  flex-direction: column;
  font-family: Montserrat-Regular;
  justify-content: center;
}
</style>
